import { useContext, useMemo } from 'react';
import RouteContext from '../../routes/context';

type AggregationSettings = {
  id: string;
  size: number;
  query?: string;
};

export const useAggregationSettings = (
  id: string
): AggregationSettings | undefined => {
  const { currentRouteState } = useContext(RouteContext);
  const { aggregations }: { aggregations: AggregationSettings[] } =
    currentRouteState;

  return useMemo(
    () =>
      aggregations?.length
        ? aggregations.find(agg => agg.id === id)
        : undefined,
    [aggregations, id]
  );
};
